<script lang="ts">
  // カットイン演出 — アニメ・ゲーム風の「上下に黒帯 (横幅一杯のレターボックス) が走り、
  // その帯の中で大きなキャラ・テキスト・効果がアニメーションする」演出。
  // variant 1〜5 で異なる帯/キャラの動きパターンを切り替える。

  import type { CharType } from '../lib/state.svelte.ts';

  interface Props {
    type: CharType | null;
    variant: number;
  }

  let { type, variant }: Props = $props();
</script>

{#key `${type}-${variant}`}
  {#if type}
    <div class="cutin-wrap variant-{variant}">
      <!-- 上の黒帯 -->
      <div class="bar bar-top"></div>
      <!-- 集中線/ストロボ等の装飾レイヤー (variant 別に表示) -->
      <div class="deco"></div>
      <!-- キャラ本体 (帯の間で動く) -->
      <div class="char-stage">
        <div class="char">
          {#if type === 'dragon'}
            <svg viewBox="-5 -10 145 85" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M5,42 Q-6,55 3,60 Q-2,50 12,46" fill="#1a6b2a"/>
              <ellipse cx="63" cy="48" rx="52" ry="18" fill="#2d8f3f"/>
              <path d="M52,33 Q32,2 8,14 Q28,22 48,34" fill="#3db05b" opacity="0.92"/>
              <path d="M68,33 Q72,4 90,8 Q78,20 70,34" fill="#3db05b" opacity="0.75"/>
              <ellipse cx="108" cy="40" rx="11" ry="13" fill="#2d8f3f"/>
              <circle cx="118" cy="28" r="11" fill="#2d8f3f"/>
              <ellipse cx="126" cy="32" rx="6" ry="4" fill="#3db05b"/>
              <circle cx="116" cy="23" r="4.5" fill="#ff8800"/>
              <circle cx="117" cy="22" r="2.5" fill="#1a1a00"/>
              <circle cx="118" cy="21" r="1" fill="white"/>
              <polygon points="116,16 112,5 120,16" fill="#1a6b2a"/>
              <rect x="32" y="64" width="8" height="14" rx="4" fill="#1a6b2a"/>
              <rect x="50" y="65" width="8" height="14" rx="4" fill="#1a6b2a"/>
              <rect x="70" y="65" width="8" height="14" rx="4" fill="#1a6b2a"/>
              <rect x="88" y="64" width="8" height="14" rx="4" fill="#1a6b2a"/>
              <polygon points="42,31 45,19 48,31" fill="#1a6b2a"/>
              <polygon points="57,28 60,14 63,28" fill="#1a6b2a"/>
              <polygon points="72,28 75,14 78,28" fill="#1a6b2a"/>
            </svg>
          {:else if type === 'rabbit'}
            <svg viewBox="0 0 64 96" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <ellipse cx="20" cy="22" rx="8" ry="22" fill="#f0f0f0"/>
              <ellipse cx="20" cy="22" rx="5" ry="19" fill="#ffb3c8"/>
              <ellipse cx="44" cy="22" rx="8" ry="22" fill="#f0f0f0"/>
              <ellipse cx="44" cy="22" rx="5" ry="19" fill="#ffb3c8"/>
              <circle cx="32" cy="42" r="20" fill="#f0f0f0"/>
              <circle cx="20" cy="46" r="6" fill="#ffb3c8" opacity="0.55"/>
              <circle cx="44" cy="46" r="6" fill="#ffb3c8" opacity="0.55"/>
              <circle cx="25" cy="38" r="4.5" fill="#cc2255"/>
              <circle cx="39" cy="38" r="4.5" fill="#cc2255"/>
              <circle cx="26" cy="37" r="2.2" fill="#220011"/>
              <circle cx="40" cy="37" r="2.2" fill="#220011"/>
              <ellipse cx="32" cy="47" rx="3.5" ry="2.5" fill="#ff88aa"/>
              <ellipse cx="32" cy="74" rx="22" ry="20" fill="#f0f0f0"/>
              <ellipse cx="18" cy="88" rx="9" ry="5" fill="#f0f0f0"/>
              <ellipse cx="46" cy="88" rx="9" ry="5" fill="#f0f0f0"/>
              <circle cx="52" cy="68" r="5" fill="white"/>
            </svg>
          {:else}
            <svg viewBox="0 0 72 90" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <ellipse cx="36" cy="45" rx="34" ry="44" fill="#7ab8e0" opacity="0.18"/>
              <path d="M10,50 Q10,14 36,14 Q62,14 62,50 L62,72 Q56,65 50,72 Q44,63 36,72 Q28,63 22,72 Q16,65 10,72 Z"
                fill="#8ec8e8" opacity="0.88"/>
              <ellipse cx="24" cy="44" rx="7" ry="9" fill="white"/>
              <ellipse cx="48" cy="44" rx="7" ry="9" fill="white"/>
              <circle cx="26" cy="46" r="5" fill="#1a3a5c"/>
              <circle cx="50" cy="46" r="5" fill="#1a3a5c"/>
              <circle cx="27" cy="44" r="2" fill="white"/>
              <circle cx="51" cy="44" r="2" fill="white"/>
              <path d="M22,60 Q27,68 36,60 Q45,68 50,60" stroke="#1a3a5c" stroke-width="2.5" fill="none" stroke-linecap="round"/>
              <path d="M17,34 Q24,28 31,34" stroke="#1a3a5c" stroke-width="2" fill="none" stroke-linecap="round"/>
              <path d="M41,34 Q48,28 55,34" stroke="#1a3a5c" stroke-width="2" fill="none" stroke-linecap="round"/>
            </svg>
          {/if}
        </div>
      </div>
      <!-- 下の黒帯 -->
      <div class="bar bar-bottom"></div>
    </div>
  {/if}
{/key}

<style>
  /* カットイン全体: 画面中央に絶対配置、上下黒帯 + 中央キャラの 3 層構造 */
  .cutin-wrap {
    position: fixed;
    top: 50%;
    left: 0;
    width: 100%;
    height: 32vh;     /* 画面高さの 1/3 を演出領域とする */
    transform: translateY(-50%);
    pointer-events: none;
    z-index: 220;
    overflow: hidden;
  }

  /* ──── 黒帯 ──── */
  .bar {
    position: absolute;
    left: 0;
    width: 100%;
    height: 14%;
    background: #0a0a0a;
    box-shadow: 0 0 12px rgba(0,0,0,0.6);
  }
  .bar-top { top: 0; }
  .bar-bottom { bottom: 0; }

  /* ──── 装飾レイヤー (集中線/ストロボ用、variant 別に表示) ──── */
  .deco {
    position: absolute;
    inset: 14% 0;       /* 上下黒帯の内側 */
    pointer-events: none;
  }

  /* ──── キャラステージ (帯の間に配置) ──── */
  .char-stage {
    position: absolute;
    inset: 14% 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .char {
    height: 80%;
    aspect-ratio: 1.2;
    will-change: transform, opacity;
  }
  .char :global(svg) {
    width: 100%;
    height: 100%;
    filter: drop-shadow(0 6px 14px rgba(0,0,0,0.6));
  }

  /* ════════════════════════════════════════════════════════════════
   * V1 標準: 黒帯が上下から走り → キャラが左から登場 → 静止 → 退場
   * ════════════════════════════════════════════════════════════════ */
  .variant-1 .bar-top    { animation: bar-top-in    1.6s cubic-bezier(0.2, 0.6, 0.4, 1) forwards; }
  .variant-1 .bar-bottom { animation: bar-bot-in    1.6s cubic-bezier(0.2, 0.6, 0.4, 1) forwards; }
  .variant-1 .char       { animation: char-slide    1.6s cubic-bezier(0.3, 0.7, 0.4, 1) forwards; }

  @keyframes bar-top-in {
    0%   { transform: translateY(-100%); }
    20%  { transform: translateY(0); }
    80%  { transform: translateY(0); }
    100% { transform: translateY(-100%); }
  }
  @keyframes bar-bot-in {
    0%   { transform: translateY(100%); }
    20%  { transform: translateY(0); }
    80%  { transform: translateY(0); }
    100% { transform: translateY(100%); }
  }
  @keyframes char-slide {
    0%   { transform: translateX(-150%) scale(0.7); opacity: 0; }
    25%  { transform: translateX(0) scale(1); opacity: 1; }
    75%  { transform: translateX(0) scale(1); opacity: 1; }
    100% { transform: translateX(150%) scale(1.0); opacity: 0; }
  }

  /* ════════════════════════════════════════════════════════════════
   * V2 集中線: 黒帯 + 中央から放射状の集中線
   * ════════════════════════════════════════════════════════════════ */
  .variant-2 .bar-top    { animation: bar-top-in 1.7s cubic-bezier(0.2, 0.6, 0.4, 1) forwards; }
  .variant-2 .bar-bottom { animation: bar-bot-in 1.7s cubic-bezier(0.2, 0.6, 0.4, 1) forwards; }
  .variant-2 .deco {
    background:
      repeating-conic-gradient(
        from 0deg,
        rgba(255,255,255,0) 0deg,
        rgba(255,255,255,0.55) 1deg,
        rgba(255,255,255,0) 4deg,
        rgba(255,255,255,0) 8deg
      );
    animation: deco-fade 1.7s ease-out forwards;
  }
  .variant-2 .char {
    animation: char-pop 1.7s cubic-bezier(0.3, 0.7, 0.3, 1) forwards;
  }
  @keyframes deco-fade {
    0%   { opacity: 0; transform: scale(0.4) rotate(0deg); }
    25%  { opacity: 0.9; transform: scale(1.0) rotate(20deg); }
    75%  { opacity: 0.7; transform: scale(1.1) rotate(40deg); }
    100% { opacity: 0; transform: scale(1.3) rotate(60deg); }
  }
  @keyframes char-pop {
    0%   { transform: scale(0.0); opacity: 0; }
    25%  { transform: scale(1.2); opacity: 1; }
    35%  { transform: scale(1.0); opacity: 1; }
    75%  { transform: scale(1.0); opacity: 1; }
    100% { transform: scale(0.8) translateY(-30%); opacity: 0; }
  }

  /* ════════════════════════════════════════════════════════════════
   * V3 斜めバー: 黒帯が斜めに切り込み + キャラ突進
   * ════════════════════════════════════════════════════════════════ */
  .variant-3 .bar-top {
    transform: skewY(-8deg);
    animation: bar-skew-top 1.5s cubic-bezier(0.2, 0.6, 0.4, 1) forwards;
  }
  .variant-3 .bar-bottom {
    transform: skewY(-8deg);
    animation: bar-skew-bot 1.5s cubic-bezier(0.2, 0.6, 0.4, 1) forwards;
  }
  .variant-3 .char {
    animation: char-rush 1.5s cubic-bezier(0.3, 0.7, 0.4, 1) forwards;
  }
  @keyframes bar-skew-top {
    0%   { transform: skewY(-8deg) translateY(-100%); }
    18%  { transform: skewY(-8deg) translateY(0); }
    82%  { transform: skewY(-8deg) translateY(0); }
    100% { transform: skewY(-8deg) translateY(-100%); }
  }
  @keyframes bar-skew-bot {
    0%   { transform: skewY(-8deg) translateY(100%); }
    18%  { transform: skewY(-8deg) translateY(0); }
    82%  { transform: skewY(-8deg) translateY(0); }
    100% { transform: skewY(-8deg) translateY(100%); }
  }
  @keyframes char-rush {
    0%   { transform: translateX(-180%) skewX(-15deg); opacity: 0; }
    20%  { transform: translateX(0) skewX(0); opacity: 1; }
    70%  { transform: translateX(0) skewX(0); opacity: 1; }
    100% { transform: translateX(180%) skewX(15deg); opacity: 0; }
  }

  /* ════════════════════════════════════════════════════════════════
   * V4 ストロボ: 黒帯が点滅、キャラはフラッシュごとに大きく揺れる
   * ════════════════════════════════════════════════════════════════ */
  .variant-4 .bar-top    { animation: bar-top-strobe 1.6s linear forwards; }
  .variant-4 .bar-bottom { animation: bar-bot-strobe 1.6s linear forwards; }
  .variant-4 .deco {
    background: rgba(255, 240, 100, 0.0);
    animation: deco-strobe 1.6s linear forwards;
  }
  .variant-4 .char {
    animation: char-shake 1.6s steps(20, end) forwards;
  }
  @keyframes bar-top-strobe {
    0%   { transform: translateY(-100%); }
    10%  { transform: translateY(0); }
    20%  { transform: translateY(0); }
    25%  { transform: translateY(-30%); }
    30%  { transform: translateY(0); }
    35%  { transform: translateY(-15%); }
    40%  { transform: translateY(0); }
    85%  { transform: translateY(0); }
    100% { transform: translateY(-100%); }
  }
  @keyframes bar-bot-strobe {
    0%   { transform: translateY(100%); }
    10%  { transform: translateY(0); }
    20%  { transform: translateY(0); }
    25%  { transform: translateY(30%); }
    30%  { transform: translateY(0); }
    35%  { transform: translateY(15%); }
    40%  { transform: translateY(0); }
    85%  { transform: translateY(0); }
    100% { transform: translateY(100%); }
  }
  @keyframes deco-strobe {
    0%, 18%, 28%, 38%, 48%, 58%, 100% { background: rgba(255, 240, 100, 0); }
    20%, 30%, 40%, 50% { background: rgba(255, 240, 100, 0.4); }
  }
  @keyframes char-shake {
    0%   { transform: scale(0.6) translateX(-100%); opacity: 0; }
    20%  { transform: scale(1.2) translateX(-3%); opacity: 1; }
    25%  { transform: scale(1.1) translateX(3%); }
    30%  { transform: scale(1.2) translateX(-2%); }
    35%  { transform: scale(1.1) translateX(2%); }
    40%  { transform: scale(1.0) translateX(0); }
    80%  { transform: scale(1.0) translateX(0); }
    100% { transform: scale(0.8) translateX(120%); opacity: 0; }
  }

  /* ════════════════════════════════════════════════════════════════
   * V5 縦バー: 左右からせり上がる縦帯 + キャラ中央停止
   * ════════════════════════════════════════════════════════════════ */
  .variant-5 .bar-top {
    height: 100%;
    width: 25%;
    background: linear-gradient(90deg, #0a0a0a 70%, transparent);
    animation: bar-vert-left 1.6s cubic-bezier(0.2, 0.6, 0.4, 1) forwards;
  }
  .variant-5 .bar-bottom {
    height: 100%;
    width: 25%;
    top: 0;
    bottom: auto;
    left: auto;
    right: 0;
    background: linear-gradient(-90deg, #0a0a0a 70%, transparent);
    animation: bar-vert-right 1.6s cubic-bezier(0.2, 0.6, 0.4, 1) forwards;
  }
  .variant-5 .char {
    animation: char-zoom 1.6s cubic-bezier(0.3, 0.7, 0.3, 1) forwards;
  }
  @keyframes bar-vert-left {
    0%   { transform: translateX(-100%); }
    20%  { transform: translateX(0); }
    80%  { transform: translateX(0); }
    100% { transform: translateX(-100%); }
  }
  @keyframes bar-vert-right {
    0%   { transform: translateX(100%); }
    20%  { transform: translateX(0); }
    80%  { transform: translateX(0); }
    100% { transform: translateX(100%); }
  }
  @keyframes char-zoom {
    0%   { transform: scale(0.0) rotate(-30deg); opacity: 0; }
    25%  { transform: scale(1.3) rotate(0); opacity: 1; }
    35%  { transform: scale(1.0) rotate(0); }
    75%  { transform: scale(1.0) rotate(0); }
    100% { transform: scale(2.0) rotate(0); opacity: 0; }
  }
</style>
